let organisationName = ''

export function setOrganisationName(value: string): void {
  organisationName = value
}

export function getOrganisationName(): string {
  return organisationName
}

export function isNtb(): boolean {
  return organisationName.trim().toLowerCase() === 'ntb'
}
